"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObserverEventBus = void 0;
const observer_1 = __importDefault(require("./observer"));
const eventBus_1 = require("../eventBus");
class ObserverEventBus extends eventBus_1.EventBusGeneric {
    constructor() {
        super(...arguments);
        this.observers = {};
    }
    publish(type, event) {
        const observer = this.observers[type];
        if (observer) {
            observer.publish(event);
        }
    }
    subscribe(type, listener) {
        const observer = this.observers[type];
        if (!observer) {
            this.observers[type] = new observer_1.default();
        }
        const unsubscriber = this.observers[type].subscribe(listener);
        return () => {
            unsubscriber();
        };
    }
}
exports.ObserverEventBus = ObserverEventBus;
//# sourceMappingURL=index.js.map